import { render, staticRenderFns } from "./EtiquetasProductos.vue?vue&type=template&id=e811f4f4"
import script from "./EtiquetasProductos.vue?vue&type=script&lang=js"
export * from "./EtiquetasProductos.vue?vue&type=script&lang=js"
import style0 from "./EtiquetasProductos.vue?vue&type=style&index=0&id=e811f4f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports